import { ScaleElement } from '@scale/base-element';

class ProductCardSwatches extends ScaleElement {
  #swatches;
  #hasHover = window.matchMedia('(hover: hover)').matches;

  setup() {
    this.#swatches = [...this.querySelectorAll('[data-variant-id]')];

    for (const swatch of this.#swatches) {
      swatch.addEventListener('mouseenter', () => this.#preview(swatch), { signal: this.signal });
      swatch.addEventListener('click', (e) => this.#handleClick(e, swatch), { signal: this.signal });
    }
  }

  #preview(swatch) {
    for (const s of this.#swatches) s.classList.remove('active');
    swatch.classList.add('active');

    const src = swatch.dataset.mediaSrc;
    const srcset = swatch.dataset.mediaSrcset;
    if (!src) return;

    const gallery = this.closest('scale-product-card')?.querySelector('scale-product-card-gallery');
    if (gallery?.updateImage) {
      gallery.updateImage(src, srcset);
    }
  }

  #handleClick(e, swatch) {
    if (!this.#hasHover) {
      const url = swatch.dataset.variantUrl;
      if (url) window.location.href = url;
    }
  }
}

if (!customElements.get('scale-product-card-swatches')) {
  customElements.define('scale-product-card-swatches', ProductCardSwatches);
}
